// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1egot","type":"styles_type__H_hQQ","choices":"styles_choices__3hfTx"};